import React from 'react'
import moment from "moment";
import { generateDaysList } from "../../utils/utils";

const DaySelector = ({ start_date, selected_date, onChange, last_date = null }) => {
    const days = generateDaysList(start_date, 30, last_date);

    return (
        <select
            onChange={e => onChange(new Date(e.target.value))}
            className="day-selector"
            value={selected_date ? moment(selected_date).format('D MMMM YYYY') : moment(start_date).format('D MMMM YYYY')}
        >
            {
                days.map(day => (
                    <option
                        value={moment(day).format('D MMMM YYYY')}
                        key={day}
                    >
                        {moment(day).format('D MMMM YYYY')}
                    </option>
                ))
            }
        </select>
    )
}

export default DaySelector;